<div class="ad-carousel" role="region" aria-roledescription="carousel" aria-label="Publicidad">

  <div class="ad-carousel__stage">
    <img *ngFor="let ad of advertisements; let i = index"
         class="ad-carousel__image"
         [class.ad-carousel__image--active]="i === currentIndex"
         [src]="ad.image"
         [alt]="ad.alt"
         [attr.aria-hidden]="i !== currentIndex" />
  </div>

  <button type="button"
          class="ad-carousel__arrow ad-carousel__arrow--left"
          aria-label="Publicidad anterior"
          (click)="prevAd()">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <button type="button"
          class="ad-carousel__arrow ad-carousel__arrow--right"
          aria-label="Siguiente publicidad"
          (click)="nextAd()">
    <mat-icon>chevron_right</mat-icon>
  </button>

  <div class="ad-carousel__dots">
    <button *ngFor="let ad of advertisements; let i = index"
            type="button"
            class="ad-carousel__dot"
            [class.ad-carousel__dot--active]="i === currentIndex"
            [attr.aria-label]="'Ir a la publicidad ' + (i + 1)"
            [attr.aria-current]="i === currentIndex"
            (click)="goToAd(i)">
    </button>
  </div>

</div>